import merge from 'lodash.merge';
import { AVAILABLE_LOCALE_FILES, LOCALE_RTL } from '../core/constants/locale';
import { i18nStore, configStore } from '../core/stores';
import messagesEn from '../i18n/en_us.json';
import { NestedRecordString } from '../core/stores/ConfigStore';

const mapFilenameByLang = {
  ar: 'ar_sa',
  be: 'be_by',
  bg: 'bg_bg',
  bs: 'bs_ba',
  cs: 'cs_cz',
  da: 'da_dk',
  de: 'de_de',
  ee: 'ee_ee',
  el: 'el_gr',
  en: 'en_us',
  es: 'es_es',
  fi: 'fi_fi',
  fr: 'fr_fr',
  ga: 'ga_ie',
  he: 'he_il',
  hr: 'hr_hr',
  hu: 'hu_hu',
  it: 'it_it',
  lt: 'lt_lt',
  mk: 'mk_mk',
  nb: 'nb_no',
  nl: 'nl_nl',
  pl: 'pl_pl',
  pt: 'pt_pt',
  ro: 'ro_ro',
  ru: 'ru_ru',
  se: 'se_se',
  sl: 'sl_si',
  sq: 'sq_al',
  sr: 'sr_rs',
  sv: 'sv_sk',
  tr: 'tr_tr',
  uk: 'uk_ua',
};

function getLangJsonFileName(lang: string) {
  const langSanitize = lang.toLowerCase().replace(new RegExp('-', 'ig'), '_');
  const fileName = mapFilenameByLang[langSanitize] || langSanitize;
  const isLangFile = AVAILABLE_LOCALE_FILES.indexOf(fileName) > -1;
  if (isLangFile) {
    return `${fileName}.json`;
  }
  const langNoLocale = langSanitize.split('_')?.[0];
  const fileNameWithoutLocale = mapFilenameByLang[langNoLocale];
  return `${fileNameWithoutLocale}.json`;
}

function mergeCustomI18n(labels: Record<string, string>, lang: string, customLabels?: NestedRecordString) {
  const i18nCustomLabels = customLabels ?? configStore.state.i18nCustomObject;
  const langNoLocale = lang.split(/(-|_)/)?.[0];
  let labelsByLangNoLocale = {};
  let labelsByLang = {};
  if (typeof langNoLocale == 'string' && langNoLocale in i18nCustomLabels) {
    labelsByLangNoLocale = i18nCustomLabels[langNoLocale];
  }
  if (typeof lang == 'string' && lang in i18nCustomLabels) {
    labelsByLang = i18nCustomLabels[lang];
  }
  return merge(labels, merge(labelsByLangNoLocale, labelsByLang));
}

export async function getI18nLabels(lang: string, customLabels?: NestedRecordString) {
  try {
    const path = configStore.state.i18nBundlesPath;
    const jsonFileName = getLangJsonFileName(lang);
    const resp = await fetch(`${path}/${jsonFileName}`);
    const i18nLabels = await resp.json();
    const finalLabels = mergeCustomI18n(i18nLabels, lang, customLabels);
    i18nStore.setState({ labels: finalLabels, lang });
  } catch (err) {
    const finalLabels = mergeCustomI18n(messagesEn, 'en', customLabels);
    i18nStore.setState({ labels: finalLabels, lang: 'en' });
  }
}

export function getLangNoLocale(lang: string) {
  if (!lang || typeof lang !== 'string') return lang
  return lang.split(/(-|_)/)?.[0]
}


export const t = i18nStore.translate.bind(i18nStore);
export function isCurrentRtlLang() {
  const langNoLocale = getLangNoLocale(i18nStore.state.lang)
  return LOCALE_RTL.findIndex(item => item === langNoLocale) > -1;
}
